import { Component, ViewChild, Optional, Inject, Input, ChangeDetectorRef, ChangeDetectionStrategy, EventEmitter, Output } from "@angular/core";
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, NgModel, NG_ASYNC_VALIDATORS, ControlContainer, NgForm } from "@angular/forms";
import { BaseControlComponent } from "../base/base-control.component";
import { HttpCommonService, LookupService } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { SelectorService } from "../base/selector.service";
@Component({
  //moduleId: module.id,
  selector: "ssg-radiobox",
  templateUrl: "./radiobox.component.html",
  styleUrls: ["./radiobox.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RadioboxComponent extends BaseControlComponent<string> {
  get Currentvalue() {
    return this.f[this.name].value;
  }
  _items: any[] = [];
  @Input()
  set items(value: any[]) {
    this._items = value;
  }
  get items(): any[] {
    return this._items;
  }
  get dataList(): any[] {
    return this.items;
  }
  set dataList(value: any[]) {
    this._items = value;
  }

  constructor(
    private _httpCommonService: HttpCommonService,
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private lookupservice: LookupService
  ) {
    super(selectorService, cd);
  }
  @Output() CompleteData = new EventEmitter<any>();

  async ngOnInit() {
    if (!this.items) this.items = [];
    super.ngOnInit();
    if (!this.dataList || this.dataList.length <= 0) {
      if (this.apiName) {
        if (!this.systemName && !this.category) {
          await this._httpCommonService
            .getList(this.apiName)
            .pipe(takeUntil(this.ngUnsubscribe))
            .toPromise()
            .then((data) => {
              this._items = data as [];
              this.selectorService.setDataList(this.name , this._items);
              this.CompleteData.emit({ apiName: this.apiName, data: data });
            });
        } else
          this.lookupservice
            .getLookupbyCategory(this.systemName, this.category)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((data) => {
              this._items = data.sort((a, b) => a.Code - b.Code) as [];
              this.selectorService.setDataList(this.name , this._items);
              this.CompleteData.emit({ apiName: this.apiName, Category: this.category, data: data });
            });
      }
    }
  }
  onChange(value: any) {
    if (!this.f[this.name].value) this.f[this.name].setValue(value[this.valueFieldName]);
    this.valueChange.emit(value);
  }
}
